import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';
import { useAppSelector } from '../../store/hooks';
import { openSalesChat } from '../../utils/chatwootActions';

type SalesChatContext =
  | 'hero'
  | 'pricing_free'
  | 'pricing_pro'
  | 'pricing_premium'
  | 'faq'
  | 'footer';

interface SalesCTAProps {
  context: SalesChatContext;
  label?: string;
  variant?: 'primary' | 'outline' | 'ghost';
  showIcon?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const SalesCTA: React.FC<SalesCTAProps> = ({
  context,
  label = 'Talk to Sales',
  variant = 'primary',
  showIcon = true,
  className = '',
  style = {},
}) => {
  const colors = useAppSelector((state) => state.theme.theme);

  const baseStyles: React.CSSProperties = {
    transition: 'all 0.2s',
    cursor: 'pointer',
    ...style,
  };

  const variantStyles: Record<string, React.CSSProperties> = {
    primary: {
      backgroundColor: colors.primary,
      color: '#fff',
      border: 'none',
    },
    outline: {
      backgroundColor: 'transparent',
      color: colors.primary,
      border: `2px solid ${colors.primary}`,
    },
    ghost: {
      backgroundColor: 'transparent',
      color: colors.primary,
      border: 'none',
    },
  };

  return (
    <button
      onClick={() => openSalesChat(context)}
      className={`inline-flex items-center gap-2 font-semibold transition-all duration-200 hover:-translate-y-0.5 active:scale-95 ${
        variant === 'ghost' ? 'text-sm hover:underline' : 'px-6 py-3 rounded-xl'
      } ${className}`}
      style={{ ...baseStyles, ...variantStyles[variant] }}
    >
      {showIcon && React.createElement(FiMessageCircle as any, { size: variant === 'ghost' ? 14 : 18 })}
      {label}
    </button>
  );
};

export default SalesCTA;
